const reEscapeChar =  /\\(\\)?/g
export default reEscapeChar
